import { render, staticRenderFns } from "./MachineItemsSingle.vue?vue&type=template&id=fb06a830"
import script from "./MachineItemsSingle.vue?vue&type=script&lang=js"
export * from "./MachineItemsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports